import loader from '../moduleLoader.js';

function DropdownButton(dropdown) {

    function init() {
        initDropdownButton(dropdown);
    }

    function initDropdownButton(dropdown) {
        var dropdownAlternatives = dropdown.getElementsByTagName('a');

        var button = document.createElement('button')
        button.className = 'dropdown-button';
        button.addEventListener('click', toggleDropdown);
        button.innerHTML = dropdown.getElementsByClassName('active')[0].innerHTML;
        dropdown.append(button);
        
        var container = document.createElement('div');
        container.className = 'dropdown__alternatives';
        dropdown.append(container);

        dropdown.addEventListener('click', e => {
            e.stopPropagation();
        });

        Array.from(dropdownAlternatives).forEach((alternative) => {
            alternative.className += ' dropdown__alternative';
            container.append(alternative);
            alternative.addEventListener('click', closeDropdown);
            alternative.addEventListener('click', setActive);
            console.log(alternative);
        });
    }
    
    function toggleDropdown(e) {
        e.preventDefault();
        e.stopPropagation();
        if (dropdown.getAttribute('aria-expanded') == 'true') {
            closeDropdown();
        } else {
            openDropdown();
        }
    }

    function closeDropdown(e) {
        if(e) e.preventDefault();
        console.log('closeDropdow');
        dropdown.setAttribute('aria-expanded', 'false');
        document.body.removeEventListener('click', closeDropdown);
    }

    function openDropdown(e) {
        if(e) e.preventDefault();
        console.log('openDropdown');
        dropdown.setAttribute('aria-expanded', 'true');
        document.body.addEventListener('click', closeDropdown);
    }

    function setActive(e) {
        var dropdownAlternatives = dropdown.getElementsByTagName('a');
        Array.from(dropdownAlternatives).forEach((alternative) => {
            alternative.className = 'dropdown__alternative';
        });
        e.target.className += ' active';
        dropdown.getElementsByClassName('dropdown-button')[0].innerHTML = e.target.innerHTML;
    }

    return {
        init: init
    }
}

loader.add('DropdownButton', DropdownButton);

export default DropdownButton;